import { render, staticRenderFns } from "./AutomaticRemittance.vue?vue&type=template&id=5fc8fbba&scoped=true&"
import script from "./AutomaticRemittance.vue?vue&type=script&lang=js&"
export * from "./AutomaticRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticRemittance.vue?vue&type=style&index=0&id=5fc8fbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8fbba",
  null
  
)

export default component.exports